import React from "react";
import { Box, Card, CardContent, CardMedia, Avatar, Typography } from "@mui/material";

const Card35Video = ({ card, handleVideoClick }) => (
  <Box sx={{ marginBottom: 4 }}>
  {card.cardMetaData?.title && (
    <Typography variant="h6" sx={{ marginBottom: 2, color: "#771615" }}>
      {card.cardMetaData.title}
    </Typography>
  )}
  <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
    {card.cardData.map((item, idx) => (
      <Card
        key={idx}
        onClick={() => handleVideoClick(item.data)} // Play video on card click
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          borderRadius: 2,
          overflow: "hidden",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          cursor: "pointer", // Indicate clickable
          background: "linear-gradient(to top, #fff 0%, #FF9800 100%)",
        }}
      >
        <CardMedia
          component="img"
          image={item.data.thumbnail}
          alt={item.data.title}
          sx={{
            height: 180,
            objectFit: "cover",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: 10,
            left: 10,
            backgroundColor: "#771615",
            color: "white",
            padding: "2px 8px",
            borderRadius: 4,
            fontSize: "12px",
          }}
        >
          {item.data.duration_display}
        </Box>
        <CardContent>
          <Typography variant="body1" fontWeight="bold" color="#771615" gutterBottom>
            {item.data.title}
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              marginTop: 1,
            }}
          >
            <Avatar
              src={item.data.streamerImageUrl}
              alt={item.data.streamerName}
              sx={{ width: 30, height: 30 }}
            />
            <Typography variant="body2" color="textSecondary">
              {item.data.streamerName}
            </Typography>
            <Typography variant="body2" sx={{ marginLeft: "auto", color: "#771615" }}>
              <span>👁 {item.data.view_count_display}</span> •{" "}
              <span>❤️ {item.data.like_count_display}</span> •{" "}
              <span>💬 {item.data.comment_count_display}</span>
            </Typography>
          </Box>
        </CardContent>
      </Card>
    ))}
  </Box>
</Box>
);

export default Card35Video;